import React from "react";
import Layout from "./components/Layout/Layout";
import "./style.scss"

function App() {
  return (
        <Layout/>
  );
}

export default App;
